import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loading from '../components/loading/Loading';
import Swal from 'sweetalert2';
// import DynamicForm from '../../Components/dynamic_form/dynamic_form';
import './Offer.css';
import axios from 'axios';

export default function DetailsGarage() {
  const location = useLocation();
  const id = decodeURIComponent(location.pathname.split('/offer/')[1]);
  const user = useSelector(state => state.user.uid);
  //const [sampleContract, setSampleContract] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Loading, please wait...');
  const [item, setItem] = useState({});
  const navigate = useNavigate();
  // const [proposal, setProposal] = useState(0);
  const [formData, setFormData] = useState([])
  const [garage, setGarage] = useState()
  const [proposal, setProposal] = useState();
  useEffect(() => {
    async function getGarage() {
      const data = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetGaragebyId', id: id })
        .then(response => {
          if (response.data.status === true) {
            return response.data.data;
          } else {
            Swal.fire({
              icon: 'info',
              title: response.data.message,
            });
            navigate('/')
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

      setGarage(data)

      setFormData([
        {
          id: 'proposal',
          type: 'number',
          toolTip: 'Set your initial proposal',
          info: 'Initial Proposal',
          value: data.rentalRate
        },
      ])

      // setSampleContract(() => {
      //   return data.sampleContractURL;
      // });


      setItem((prev) => (
        {
          ...prev,
          ...data,
        }
      ));

      // console.log(data);

      if (data) {
        setLoading(false);
      } else {
        setLoadingText("We couldn't find the garage, maybe it has been removed or rented");
      }
    }

    if (id) {
      getGarage(id);
    }
  }, [id]);

  useEffect(() => {
    if (user === 'none') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `You need to be logged.`,
      }).then(() => {
        navigate('/login');
      })
    }
  }, [user])

  async function onSubmitForm(event) {
    event.preventDefault();
    if (proposal) {
      Swal.fire({
        title: 'Negotiation Creating...',
        html:
          '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
        showConfirmButton: false,
        showCancelButton: false,
        focusConfirm: false,
      });

      const { ownerID } = garage
      const parameters = {
        action: 'AddNegotiations',
        currentProposal: proposal,
        currentProposalUID: user,
        clientID: user,
        ownerID: ownerID,
        garageID: id,
        garageAddress: item.address,
        rentalRate: item.rentalRate,
        dealClosed: false
      }
      try {
        const response1 = await axios.post(`${process.env.REACT_APP_API_URL}`, parameters);

        if (response1.data.status === true) {
          const paameters2 = {
            action: 'AddNegotiationsMeta',
            negotiation_id: response1.data.data,
            message: `I propose: $${proposal}`,
            UID: user,
            proposal: true,
          };
          await axios.post(`${process.env.REACT_APP_API_URL}`, paameters2)
            .then(response => {
              Swal.close();
              Swal.fire({
                icon: 'success',
                title: 'Negotiation Created',
                text: 'You should review your negotiations by clicking "My Negotiations" in the down right corner of the screen'
              }).then(() => {
                navigate('/');
              })
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Something went wrong creating the negotiation${error}`,
              })
            });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error Negotiation Created ',
            text: response1.data.message
          })
        }
      } catch (error) {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `Something went wrong creating the negotiation: ${error}`,
        });
      }
    }
  }
  return (

    <section className="page-content sec-padding">
      <div className="container-fluid">
        <div className="page-content-details">
          <div className="sec-title row">
            <div className="col-md-12 text-cnter">
              <h3>Make Offer</h3>
            </div>

          </div>
          {loading ?
            <Loading text={loadingText} />
            :
            <div className='row'>
              <div className='col-md-6 mx-auto'>
                <form className="form-gp">

                  <table className='table garagedetailTable'>
                    <tbody>
                      <tr>
                        <td style={{ width: '3%' }}><i className='fa fa-map-marker strong'></i></td>
                        <td><span className='strong'>Address:</span></td>
                        <td> {item && item.address}</td>
                      </tr>
                      <tr>
                        <td><i className='fa fa-dollar strong'></i></td>
                        <td><span className='strong'>Rental Rate:</span></td>
                        <td> ${item && item.rentalRate}</td>
                      </tr>
                      <tr>
                        <td><i className='fa fa-dollar strong'></i></td>
                        <td><span className='strong'>Late Charge:</span></td>
                        <td> ${item && item.lateCharge}</td>
                      </tr>
                      <tr>
                        <td><i className='fa fa-dollar strong'></i></td>
                        <td><span className='strong'>Bounce Fee:</span></td>
                        <td> ${item && item.bounceFee}</td>

                      </tr>
                      <tr>
                        <td><i className='fa fa-home strong'></i></td>
                        <td colSpan={2}><span className='strong'>Contract:</span></td>
                      </tr>

                      <tr>
                        <td colSpan={2}><span className='strong'>Initial Proposal:</span></td>
                        <td> <input type='number' className='form-control' id='proposal' name='proposal' value={proposal} onChange={(e) => setProposal(e.target.value)} /></td>
                      </tr>


                    </tbody>
                  </table>
                  <div className="form-group">
                    <button type="submit" className="btn btn-primary btn-lg" onClick={onSubmitForm} >Confirm</button>
                  </div>
                </form>
              </div>
            </div>
          }
        </div>
      </div>
    </section>


  )
};